import React from 'react'
import Button from './button'

export default function Ctas({ buttons, size, color }) {
  if (!color) {
    throw new Error('<Ctas> error: The `color` prop is required.')
  }

  if (!size) {
    throw new Error('<Ctas> error: The `size` prop is required.')
  }

  return (
    buttons?.length && (
      <ul className="flex flex-wrap gap-4">
        {buttons.map(({ link }, index) => (
          <li key={`link-${index}`}>
            <Button color={color} outline={index % 2} size={size} {...link} />
          </li>
        ))}
      </ul>
    )
  )
}
